import { useContext } from 'react';

import PropTypes from 'prop-types';

import { AuthContext } from '../../../../../actions/auth-context';
import { spreadEditionPendencies } from '../../../../../commons/order-checklist';

// Finaliza a edição das lâminas (editor) — envia para a inspeção de lâminas.
// Checklist (05/07): ≥1 lâmina e NENHUMA reprovada pela inspeção — o botão
// fica visível porém desabilitado listando as pendências (padrão dos demais).
const FinishSpreadEditingButton = ({ order }) => {
  const { hasPermissions } = useContext(AuthContext);

  const viewButton =
    order.order_status === 'Em edição de lâminas' &&
    hasPermissions(['edit_photos', 'edit_order']);

  const pendencies = spreadEditionPendencies(order);

  const ready = pendencies.length === 0;

  return (
    <>
      {viewButton && (
        <div className="col-sm col-md-6 col-xl-4 mt-2">
          {!ready && (
            <div
              className="alert alert-warning py-2 px-3 mb-2 text-start"
              style={{ fontSize: '12px', textTransform: 'none' }}
            >
              <b>Pendências para finalizar as lâminas:</b>
              <ul className="mb-0 ps-3">
                {pendencies.map((pendency) => (
                  <li key={pendency}>{pendency}</li>
                ))}
              </ul>
            </div>
          )}

          <button
            className="btn btn-success btn-block col-12"
            type="button"
            disabled={!ready}
            data-bs-toggle={ready ? 'modal' : undefined}
            data-bs-target={
              ready ? '#modal-finish-spread-editing-order' : undefined
            }
          >
            finalizar edição de lâminas
          </button>
        </div>
      )}
    </>
  );
};

FinishSpreadEditingButton.propTypes = {
  order: PropTypes.shape({
    id: PropTypes.string,
    order_status: PropTypes.string,
    photos: PropTypes.arrayOf(Object),
  }).isRequired,
};

export default FinishSpreadEditingButton;
